import { useMemo, useRef, useEffect } from 'react'
import { Alert } from 'antd'
import classNames from 'classnames'
import styles from '@Orders/OrderDetailsPage/styles.css'

import Box from '~/core/Box'
import { salesOrder_salesOrder_shipments_items as ItemsType } from '../Queries/__generated__/salesOrder'

import { getShipmentCount } from './logic'
import Shipment from './Shipment'
import { ShipmentListType } from './types'

export default function ShipmentList(props: ShipmentListType) {
    const {
        shipmentTotal,
        shipments,
        salesOrderLinesTotal,
        isImOrder,
        selectedShipmentId,
        shipmentIdsMap,
        salesOrderLines,
    } = props

    const shipmentsRef = useRef<HTMLDivElement[]>([])

    useEffect(() => {
        const selectedShipmentClassname = classNames(styles.shipmentSelected)
        const containsClassName = (shipmentSection: Element) =>
            shipmentSection?.classList.contains(selectedShipmentClassname)
        const addClassName = (shipmentSection: Element) =>
            shipmentSection?.classList.add(selectedShipmentClassname)
        const removeClassName = (shipmentSection: Element) =>
            shipmentSection?.classList.remove(selectedShipmentClassname)

        shipmentsRef.current.forEach((shipmentSection: HTMLElement) => {
            if (
                selectedShipmentId &&
                shipmentSection?.id.includes(selectedShipmentId)
            ) {
                shipmentSection.children[0].scrollIntoView()
                addClassName(shipmentSection?.children[0])
            } else {
                if (containsClassName(shipmentSection?.children[0])) {
                    removeClassName(shipmentSection?.children[0])
                }
            }
        })
    }, [selectedShipmentId])

    const shipmentLinesContent = useMemo(() => {
        return shipments.map((shipment: ItemsType) => {
            return (
                <div
                    ref={(element: HTMLDivElement) =>
                        shipmentsRef.current.push(element)
                    }
                    id={shipment.id}
                    key={shipment.id}
                >
                    <Shipment
                        id={shipment.id}
                        shipmentCount={getShipmentCount(
                            shipment?.id,
                            shipmentIdsMap,
                        )}
                        shipmentTotal={shipmentTotal}
                        shipmentData={shipment}
                        shipmentMethod={shipment.shippingMethod}
                        isImOrder={isImOrder}
                        salesOrderLines={salesOrderLines}
                    />
                </div>
            )
        })
    }, [shipments, shipmentIdsMap, shipmentTotal, isImOrder, salesOrderLines])

    const getShipments = () => {
        if (shipmentTotal && shipmentTotal < 0) {
            return null
        }

        const multipleShipmentMsg =
            shipmentTotal > 1 ||
            (shipmentTotal === 1 && salesOrderLinesTotal) ? (
                <Box marginBottom="12px">
                    <Alert
                        style={{ width: '100%' }}
                        message={
                            <Box marginTop="2px">
                                Your order contains multiple shipments.
                            </Box>
                        }
                        type="info"
                        showIcon
                    />
                </Box>
            ) : (
                ''
            )

        return (
            <>
                {multipleShipmentMsg}
                {shipmentLinesContent}
            </>
        )
    }

    return getShipments()
}
